export function readRowString($row, attributeName) {
    const value = $row.attr('data-' + attributeName);
    if (value == null || value === '') {
        return '';
    }
    return String(value);
}

export function readRowFlag($row, attributeName) {
    return $row.attr('data-' + attributeName) === '1';
}

export function readRowNumber($row, attributeName) {
    const raw = readRowString($row, attributeName);
    if (raw === '') {
        return 0;
    }
    const num = parseFloat(raw);
    return Number.isFinite(num) ? num : 0;
}

export function readPledgeDataFromRow($row) {
    return readPledgeActionDataFromRow($row);
}

export function readPledgeActionDataFromRow($row) {
    const pledgeId = readRowString($row, 'pledge-id');
    return {
        id: pledgeId === '' ? 0 : Number(pledgeId),
        table_name: readRowString($row, 'table-name') || 'pledge',
        type: readRowString($row, 'pledge-type'),
        paid: readRowFlag($row, 'paid') ? 1 : 0,
        matanah: readRowFlag($row, 'matanah') ? 1 : 0,
        recurring: readRowFlag($row, 'recurring') ? 1 : 0,
        active_ongoing: readRowFlag($row, 'active-ongoing') ? 1 : 0,
        is_cancelled: readRowFlag($row, 'cancelled') ? 1 : 0,
        is_failed: readRowFlag($row, 'failed') ? 1 : 0,
        awaiting_activation: readRowFlag($row, 'awaiting-activation') ? 1 : 0,
        amount: readRowNumber($row, 'amount'),
        balance_due: readRowNumber($row, 'balance-due'),
        num_left: readRowNumber($row, 'num-left'),
        installment_amount: readRowNumber($row, 'installment-amount'),
        surcharge_amount: readRowNumber($row, 'surcharge-amount'),
        ongoing_indefinitely: readRowFlag($row, 'ongoing-indefinitely') ? 1 : 0,
        user_email: readRowString($row, 'user-email'),
        user_phone: readRowString($row, 'user-phone'),
        statement_sent: readRowFlag($row, 'statement-sent') ? 1 : 0,
        allow_delete: readRowFlag($row, 'allow-delete') ? 1 : 0,
        added_by: readRowString($row, 'added-by'),
        user_name: readRowString($row, 'user-name'),
        user_id: readRowString($row, 'user-id'),
        campaign_id: readRowString($row, 'campaign-id'),
        gateway_id: readRowString($row, 'gateway-id'),
        description: readRowString($row, 'description'),
    };
}
